<template>
  <section class="py-5 container">
    <div class="row">
      <div class="col">

        <div class="text-center">
          <h1 class="fw-light">Recherche de problèmes</h1>
          <p class="lead text-muted">Sélectionnez les caractéristiques. Explorer selon les typologies.</p>
          <p>
            <a class='btn btn-outline-success fix-margin' data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Caractéristiques</a>
          </p>
        </div>
        <div class="collapse multi-collapse" id="multiCollapseExample1">
          <table class="table table-hover">
            <tbody>
              <tr class="table-warning">
                <th>Niveau</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="cp" value="CP" v-model="levels">
                  <label class="form-check-label" for="cp">
                    CP
                    <b-badge pill class="facet" v-if="facets.level.CP">{{facets.level.CP}}</b-badge>
                    </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="ce1" value="CE1" v-model="levels">
                  <label class="form-check-label" for="ce1">CE1
                    <b-badge pill class="facet" v-if="facets.level.CE1">{{facets.level.CE1}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="ce2" value="CE2" v-model="levels">
                  <label class="form-check-label" for="ce2">CE2
                    <b-badge pill class="facet" v-if="facets.level.CE2">{{facets.level.CE2}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="cm1" value="CM1" v-model="levels">
                  <label class="form-check-label" for="cm1">CM1
                    <b-badge pill class="facet" v-if="facets.level.CM1">{{facets.level.CM1}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="cm2" value="CM2" v-model="levels">
                  <label class="form-check-label" for="cm2">CM2
                    <b-badge pill class="facet" v-if="facets.level.CM2">{{facets.level.CM2}}</b-badge>
                  </label>
                </td>
              </tr>
              <tr class="table-info">
                <th>Catégorie</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="add" value="ADD" v-model="categories">
                  <label class="form-check-label" for="add">Additif (+ et -)
                    <b-badge pill class="facet" v-if="facets.category.ADD">{{facets.category.ADD}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="mul" value="MUL" v-model="categories">
                  <label class="form-check-label" for="mul">Multiplicatif
                    <b-badge pill class="facet" v-if="facets.category.MUL">{{facets.category.MUL}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="div" value="DIV" v-model="categories">
                  <label class="form-check-label" for="div">Division/partage
                    <b-badge pill class="facet" v-if="facets.category.DIV">{{facets.category.DIV}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="prop" value="PROP" v-model="categories">
                  <label class="form-check-label" for="prop">Proportionnalité
                    <b-badge pill class="facet" v-if="facets.category.PROP">{{facets.category.PROP}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="num" value="NUM" v-model="categories">
                  <label class="form-check-label" for="num">Autre
                    <b-badge pill class="facet" v-if="facets.category.NUM">{{facets.category.NUM}}</b-badge>
                  </label>
                </td>
              </tr>
              <tr class="table-success">
                <th>Domaine</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="int" value="INT" v-model="domains">
                  <label class="form-check-label" for="int">Entiers
                    <b-badge pill class="facet" v-if="facets.domain.INT">{{facets.domain.INT}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="dec" value="DEC" v-model="domains">
                  <label class="form-check-label" for="dec">Décimaux
                    <b-badge pill class="facet" v-if="facets.domain.DEC">{{facets.domain.DEC}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="frac" value="FRAC" v-model="domains">
                  <label class="form-check-label" for="frac">Fractions
                    <b-badge pill class="facet" v-if="facets.domain.FRAC">{{facets.domain.FRAC}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="geo" value="GEO" v-model="domains">
                  <label class="form-check-label" for="geo">Géométrie
                    <b-badge pill class="facet" v-if="facets.domain.GEO">{{facets.domain.GEO}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="logos" value="LOGOS" v-model="domains">
                  <label class="form-check-label" for="logos">Logique
                    <b-badge pill class="facet" v-if="facets.domain.LOGOS">{{facets.domain.LOGOS}}</b-badge>
                  </label>
                </td>
              </tr>
              <tr class="table-danger">
                <th>Complexité</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="one" value="one" v-model="complexities">
                  <label class="form-check-label" for="one">Une étape
                    <b-badge pill class="facet" v-if="facets.complexity.one">{{facets.complexity.one}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="more" value="more" v-model="complexities">
                  <label class="form-check-label" for="more">Plus d'une étape
                    <b-badge pill class="facet" v-if="facets.complexity.more">{{facets.complexity.more}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="atypique" value="atypique" v-model="complexities">
                  <label class="form-check-label" for="atypique">Atypique
                    <b-badge pill class="facet" v-if="facets.complexity.atypique">{{facets.complexity.atypique}}</b-badge>
                  </label>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr v-show="categories.includes('ADD') && categories.length == 1">
                <th class="typo">Additif</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="compos" value="compos" v-model="typoAdd"><!-- :disabled="categories != 'ADD'"-->
                  <label class="form-check-label" for="compos">Composition
                    <b-badge pill class="facet" v-if="facets.typoAdd.compos">{{facets.typoAdd.compos}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="trans" value="trans" v-model="typoAdd"><!-- :disabled="categories != 'ADD'"-->
                  <label class="form-check-label" for="trans">Transformation
                    <b-badge pill class="facet" v-if="facets.typoAdd.trans">{{facets.typoAdd.trans}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="compar" value="compar" v-model="typoAdd"><!-- :disabled="categories != 'ADD'"-->
                  <label class="form-check-label" for="compar">Comparaison
                    <b-badge pill class="facet" v-if="facets.typoAdd.compar">{{facets.typoAdd.compar}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="compos-de-trans" value="compos-de-trans" v-model="typoAdd"><!-- :disabled="categories != 'ADD'"-->
                  <label class="form-check-label" for="compos-de-trans">Compo. de transfo.
                    <b-badge pill class="facet" v-if="facets.typoAdd['compos-de-trans']">{{facets.typoAdd['compos-de-trans']}}</b-badge>
                  </label>
                </td>
                <td></td>
              </tr>
              <tr v-show="categories.includes('MUL') && categories.length == 1">
                <th class="typo">Multiplicatif</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="n-times" value="n-times" v-model="typoMul"><!-- :disabled="categories != 'MUL'"-->
                  <label class="form-check-label" for="n-times">n fois plus/moins
                    <b-badge pill class="facet" v-if="facets.typoMul['n-times']">{{facets.typoMul['n-times']}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="rect" value="rect" v-model="typoMul"><!-- :disabled="categories != 'MUL'"-->
                  <label class="form-check-label" for="rect">Rectangulaire
                    <b-badge pill class="facet" v-if="facets.typoMul.rect">{{facets.typoMul.rect}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="cartesian" value="cartesian" v-model="typoMul"><!-- :disabled="categories != 'MUL'"-->
                  <label class="form-check-label" for="cartesian">Produit cartésien
                    <b-badge pill class="facet" v-if="facets.typoMul.cartesian">{{facets.typoMul.cartesian}}</b-badge>
                  </label>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr v-show="categories.includes('DIV') && categories.length == 1">
                <th class="typo">Division</th>
                <td>
                  <input class="form-check-input" type="checkbox" id="partition" value="partition" v-model="typoDiv"><!-- :disabled="categories != 'DIV'"-->
                  <label class="form-check-label" for="partition">Partition
                    <b-badge pill class="facet" v-if="facets.typoDiv.partition">{{facets.typoDiv.partition}}</b-badge>
                  </label>
                </td>
                <td>
                  <input class="form-check-input" type="checkbox" id="quotition" value="quotition" v-model="typoDiv"><!-- :disabled="categories != 'DIV'"-->
                  <label class="form-check-label" for="quotition">Quotition
                    <b-badge pill class="facet" v-if="facets.typoDiv.quotition">{{facets.typoDiv.quotition}}</b-badge>
                  </label>
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'SearchItem',
  props: {
    facets: Object
  },
  data() {
    return {
      levels: [],
      categories: [],
      domains: [],
      complexities: [],
      typoAdd: [],
      typoMul: [],
      typoDiv: []
    } 
  },
  computed: {
    filters() {
      let levelsFilter = computeOR(this.levels, 'level')
      let categoriesFilter = computeOR(this.categories, 'category')
      let domainsFilter = computeOR(this.domains, 'domain')
      let complexitiesFilter = computeOR(this.complexities, 'complexity')      
      let filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter])
      if(this.categories == 'ADD') {
        let typoAddFilter = computeOR(this.typoAdd, 'typoAdd')
        filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter, typoAddFilter])
      }
      if(this.categories == 'MUL') {
        let typoMulFilter = computeOR(this.typoMul, 'typoMul')
        filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter, typoMulFilter])
      }
      if(this.categories == 'DIV') {
        let typoDivFilter = computeOR(this.typoDiv, 'typoDiv')
        filters = computeAND([levelsFilter, categoriesFilter, domainsFilter, complexitiesFilter, typoDivFilter])
      }
      return filters
    }
  },
  watch: { filters() { this.$emit('refresh', this.filters) } }
}

let computeOR = function(array, name) {
  if(array.length > 0) {
    let filter = array.map(item => `${name}:${item} OR`).join(' ').slice(0, -3)
    return `(${filter})`
  } else {
    return null
  }
}

let computeAND = function(array) {
  let filters = array.map(item => item ? `${item} AND`: null).join(' ')
  filters = filters.trim()
  let l = filters.length
  let endFilters = filters.substring(l - 4, l)
  if(endFilters == ' AND') { filters = filters.slice(0, -4) }
  return filters
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* bootstrap-vue fixing */
    .fix-margin {
      margin: 0px 4px 0px 4px;
      box-shadow: 0 1px 3px black;
    }
    .problem-number-div {
      margin-top: 16px;
    }
    .py-5 {
      padding-bottom: 1rem !important;
    }
    .typo {
      color: #198754
    }
    .facet {
      background-color:#6c757d94
    }
</style>